import { Box, Container, Typography, Button, Fade, Slide } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import img_onurb_pass from "../../assets/images/prod_onurb_pass.svg";
import img_onurb_finance from "../../assets/images/prod_onurb_finance.svg";
import img_transparencia from "../../assets/images/prod_transparencia.svg";

const products = [
  {
    title: "ONURB Pass",
    meta: "Venda de ingressos com checkout transparente e parcelamento até 3x sem juros.",
    image: img_onurb_pass,
    cta: {
      label: "Quero vender com a ONURB",
      to: "/organizadores",
      variant: "primary",
    },
  },
  {
    title: "ONURB Finance",
    meta: "Repasses • Conciliação • Governança",
    image: img_onurb_finance,
    cta: {
      label: "Entender o financeiro",
      to: "/organizadores#finance",
      variant: "outlined",
    },
  },
  {
    title: "Transparência",
    meta: "Taxas claras • Valores visíveis • Confiança",
    image: img_transparencia,
    cta: {
      label: "Ver taxas",
      to: "/taxas",
      variant: "outlined",
    },
  },
];

export default function OrganizerProducts() {
  return (
    <Box sx={{ py: { xs: 6, md: 7 } }} id="produtos">
      <Container maxWidth={false} sx={{ maxWidth: "1120px", px: 2 }}>
        {/* HEADER */}
        <Slide direction="up" in timeout={600}>
          <Box sx={{ mb: 3 }}>
            <Fade in timeout={800}>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 900,
                    letterSpacing: "-0.01em",
                    mb: 1,
                  }}
                >
                  Para organizadores
                </Typography>

                <Typography
                  sx={{
                    maxWidth: "60ch",
                    opacity: 0.75,
                    lineHeight: 1.6,
                  }}
                >
                  Venda ingressos com a ONURB Pass e opere o financeiro com a
                  governança da ONURB Finance.
                </Typography>
              </Box>
            </Fade>
          </Box>
        </Slide>

        {/* PRODUCTS */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, 1fr)",
            },
            gap: 2,
          }}
        >
          {products.map((prod, idx) => (
            <Slide key={prod.title} direction="up" in timeout={600 + idx * 120}>
              <Fade in timeout={800 + idx * 120}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "26px",
                    overflow: "hidden",
                    border: "1px solid var(--linha)",
                    background: "rgba(255,255,255,0.04)",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.24)",
                  }}
                >
                  {/* IMAGE */}
                  <Box
                    sx={{
                      height: 160,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 2,
                    }}
                  >
                    <img
                      src={prod.image}
                      alt={prod.title}
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  </Box>

                  {/* BODY */}
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      flexGrow: 1,
                    }}
                  >
                    <Typography sx={{ fontWeight: 900, mb: 1 }}>
                      {prod.title}
                    </Typography>

                    <Typography sx={{ opacity: 0.7, mb: 2 }}>
                      {prod.meta}
                    </Typography>

                    <Button
                      component={RouterLink}
                      to={prod.cta.to}
                      variant={
                        prod.cta.variant === "primary"
                          ? "contained"
                          : prod.cta.variant === "secondary"
                            ? "text"
                            : "outlined"
                      }
                      sx={{
                        mt: "auto",
                        fontWeight: 900,
                        borderRadius: "14px",
                      }}
                    >
                      {prod.cta.label}
                    </Button>
                  </Box>
                </Box>
              </Fade>
            </Slide>
          ))}
        </Box>

        {/* NOTE */}
        <Fade in timeout={900}>
          <Box
            sx={{
              mt: 2,
              border: "1px solid rgba(255,255,255,0.14)",
              background: "rgba(255,255,255,0.04)",
              borderRadius: "26px",
              p: 2.5,
              opacity: 0.8,
            }}
          >
            <Typography sx={{ lineHeight: 1.6 }}>
              A gestão financeira e os repasses dos eventos são realizados pela{" "}
              <strong>ONURB Finance</strong>, infraestrutura financeira do grupo
              ONURB.
            </Typography>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
}
